<template>
  <el-container>
    <el-main style='height:100vh;padding:0px'>
      <div  class='div-form'>
      <el-form :label-position='labelPosition' :model='formUser' :rules='rules' label-width='80px'  size='mini'  ref='formUser'>
        <el-form-item label='用户名'  prop ='username'>
        <el-col :span='10'>
          <el-input v-model='formUser.username'  ></el-input>
        </el-col>
        </el-form-item>
        <el-form-item label='密码'  prop ='password'>
          <el-col :span='10'>
          <el-input v-model='formUser.password'  ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label='角色'  prop='role'>-->
          <el-col :span='10'>
        <el-select v-model='formUser.role'  style='width:100%'  placeholder='请选择角色类型'>
           <el-option label='超级管理员' value='超级管理员'></el-option>
<!--           <el-option label='普通用户' value='1'></el-option>-->
          </el-select>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span='10'>
          <el-button type='primary' @click='save(formUser)' >保存</el-button>
          <el-button plain @click='reset'>重置</el-button>
          <el-button plain @click='closed'>返回</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import axios from '../../../utils/request'

export default {
  data () {
    return {
      state: 0,
      companynames: [],
      formUser: {
        username: '',
        password: '',
        role: ''
      },
      rules: {
        username: [
          { required: true, message: '请填用户名', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请填密码', trigger: 'change' }
        ],
        role: [
          { required: true, message: '请填角色类型', trigger: 'change' }
        ]
      },
      roles: [{label: '超级管理员', value: '超级管理员'}],
      users: []
    }
  },
  mounted () {
    this.loading()
  },
  methods: {
    save: function (formUser) {
      this.loading1 = true
      console.log(this.$refs.formUser)
      console.log(1111)
      this.$refs.formUser.validate((valid) => {
        if (valid) {
          console.log(valid)
          let params = this.formUser
          axios.post('/user/adduser', params).then(res => {
            console.log('success')
            this.$router.push('/data/user')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    reset: function () {
      this.formUser.username = ''
      this.formUser.password = ''
      this.formUaccount.role = ''
    },
    closed: function () {
      this.$router.push('/data/user')
    },
    loading: function () {
    }
  }
}
</script>

<style scoped>
  .el-container {
    height: 100%;
  }
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .div-form{
    margin-top: 100px;
    margin-left: 280px;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/user/adduser.vue